export const CELL_RENDERER = {
  TEXT: "SFCellTextRenderer",
  ACTIONS: "SFActionsRenderer",
  CHECKBOX: "SFCheckboxCellRenderer",
  DETAIL_CLICKABLE: "SFURLRenderer",
  BOOLEAN: "SFBooleanRenderer",
  PROGRESS_BAR: "SFProgressBarRenderer",
  EDIT_CLICKABLE: "SFEditRenderer",
  ROW_DRAGGING: "SFRowDraggingRenderer",
  TREND: "SFTrendRenderer",
  MASTER_DETAIL: "SFMasterDetailCellRenderer",
  STATUS: "SFStatusRenderer",
};

export const HEADER_RENDERED = {
  DEFAULT: "SFColumnHeaderRenderer"
};

export const FILTER_TYPES = {
  DROPDOWN: "dropdown",
  BOOLEAN: "boolean",
  CATEGORY: "category",
  HIERARCHY: "hierarchy",
  NUMBER: "agNumberColumnFilter",
  DATE: "agDateColumnFilter",
  RADIO: "radio",
};

export const GRID_FILTERS = {
  filterType: {
    set: "set",
    number: "number",
    groupTreeFilter: "groupTreeFilter",
    date: "date",
  },
  type: {
    equals: "equals",
    notEqual: "notEqual",
    lessThan: "lessThan",
    lessThanOrEqual: "lessThanOrEqual",
    greaterThan: "greaterThan",
    greaterThanOrEqual: "greaterThanOrEqual",
    inRange: "inRange",
    blank: "blank",
    notBlank: "notBlank",
  },
  operator: { and: "AND", or: "OR" },
};

export const GRID_SORTINGS = {
  ASC: "asc",
  DESC: "desc"
};